import { zodValidator } from '@tanstack/zod-adapter';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { TemplateCategoriesPage } from '../features/templates/template-categories-page';

const SearchSchema = z.object({
  kind: z.enum(['all', 'system', 'custom']).optional().catch(undefined),
  q: z.string().max(200).optional().catch(undefined),
  sort: z
    .enum(['updated-desc', 'updated-asc', 'name-asc', 'templates-desc'])
    .optional()
    .catch(undefined),
});

export const Route = createFileRoute('/manage/$companySlug/template-categories')({
  component: RouteComponent,
  validateSearch: zodValidator(SearchSchema),
});

function RouteComponent() {
  const { companySlug } = Route.useParams();
  const { kind, q, sort } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <TemplateCategoriesPage
      companySlug={companySlug}
      kind={kind ?? 'all'}
      onClearFilters={() =>
        void navigate({ replace: true, search: { kind: undefined, q: undefined, sort: undefined } })
      }
      onKindChange={(next) =>
        void navigate({ replace: true, search: (previous) => ({ ...previous, kind: next }) })
      }
      onSearchChange={(next) =>
        void navigate({ replace: true, search: (previous) => ({ ...previous, q: next }) })
      }
      onSortChange={(next) =>
        void navigate({ replace: true, search: (previous) => ({ ...previous, sort: next }) })
      }
      search={q}
      sort={sort ?? 'updated-desc'}
    />
  );
}
